export const iconFontAwesomeAnimalsShieldCat = (
	<i className="fa-solid fa-shield-cat"></i>
);
